import ProductInfoForm from './product-info-form'

export default ProductInfoForm;